
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticStyle:{"isolation":"isolate"},attrs:{"data-name":"Path 450","d":"M40 16.7v-5.78a3.65 3.65 0 016.22-2.58L62.94 25a3.63 3.63 0 010 5.12l-16.7 16.7a3.64 3.64 0 01-6.24-2.5v-6.15C21.83 38.17 9.1 44 0 56.72 3.64 38.53 14.55 20.34 40 16.7z"}})])
          )
        }
      }
    